// Module
var code = "{{#__showExportCSVButton}}\r\n<button id=\"exportCSVBtn\" class=\"btn btn-primary btn-action-bar\" title=\"esporta visibili\" type=\"button\"><span class=\"fas fa-file-export\"></span></button>\r\n{{/__showExportCSVButton}}";
// Exports
export default code;